export const VRInformationModeEnum = {
    SCENE_FIX: "scene-fix",
    SCENE_FOLLOW: "scene-follow",
    CAMERA_FIX: "camera-fix",
};

export const SceneFollowPositionEnum = {
    TOP: "Top",
    BOTTOM : "Bottom",
    MIDDLE: "Middle",
    DEFAULT: "Default"
};

export const PositionOffsetEnum = {
    TOP: 1.5,
    BOTTOM : -.5,
    MIDDLE: .5,
    DEFAULT: 0
};

export const DefaultScenePosition = {
    x: 0,
    y: -.7,
    z: -4
};